import { Ban } from "lucide-react";

import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

import type { CannotDeleteCommentVariant } from "../hooks/useDeleteChatComment";

const DESCRIPTION_BY_VARIANT: Record<CannotDeleteCommentVariant, string> = {
  "feedback-blocked":
    "This comment has files with feedback tool comments attached, and can not be deleted.",
  "permission-denied": "You don’t have permission to delete this comment.",
};

interface CannotDeleteCommentModalProps {
  isOpen: boolean;
  onClose: () => void;
  variant: CannotDeleteCommentVariant;
}

export function CannotDeleteCommentModal({
  isOpen,
  onClose,
  variant,
}: CannotDeleteCommentModalProps) {
  return (
    <Modal isOpen={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog>
        <DialogBody className="flex flex-row gap-xl">
          <div className="grid size-6xl shrink-0 place-items-center rounded-full bg-bg-error-secondary">
            <Ban className="text-featured-icon-light-fg-error" />
          </div>
          <div className="flex flex-col gap-xs">
            <span className="text-lg font-semibold text-text-primary">
              Can’t delete comment
            </span>
            <DialogCloseButton />
            <span className="text-sm text-text-tertiary">
              {DESCRIPTION_BY_VARIANT[variant]}
            </span>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button color="gray" onPress={onClose} size="lg" variant="secondary">
            Got it
          </Button>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
